var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTripleGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 139,
    height: 66,
    viewBox: "0 0 139 66",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1024_2039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.7959 37.8255C66.5998 20.3203 54.682 3.85657 37.1768 1.05269C19.6716 -1.75119 3.20784 10.1666 0.403959 27.6718C-2.39992 45.177 9.51786 61.6408 27.0231 64.4447C44.5283 67.2486 60.992 55.3307 63.7959 37.8255Z",
    stroke: "#E0410E",
    strokeWidth: 0.67,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4999 64.9952V0.69519",
    stroke: "#E0410E",
    strokeWidth: 0.67,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7999 59.2951V6.49512",
    stroke: "#E0410E",
    strokeWidth: 0.67,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0999 59.2951V6.49512",
    stroke: "#E0410E",
    strokeWidth: 0.67,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5999 32.8951H0.299881",
    stroke: "#E0410E",
    strokeWidth: 0.67,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8999 51.1952H6.09988",
    stroke: "#E0410E",
    strokeWidth: 0.67,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8999 14.4951H6.09988",
    stroke: "#E0410E",
    strokeWidth: 0.67,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.616 37.8887C103.42 20.3835 91.5022 3.91974 73.997 1.11586C56.4918 -1.68802 40.0281 10.2297 37.2242 27.7349C34.4203 45.2402 46.3381 61.7039 63.8433 64.5078C81.3485 67.3117 97.8123 55.3939 100.616 37.8887Z",
    stroke: "#E0410E",
    strokeWidth: 0.67,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2999 64.9952V0.69519",
    stroke: "#E0410E",
    strokeWidth: 0.67,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5999 59.2951V6.49512",
    stroke: "#E0410E",
    strokeWidth: 0.67,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9999 59.2951V6.49512",
    stroke: "#E0410E",
    strokeWidth: 0.67,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.4 32.8951H37.1999",
    stroke: "#E0410E",
    strokeWidth: 0.67,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6999 51.1952H42.8999",
    stroke: "#E0410E",
    strokeWidth: 0.67,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6999 14.4951H42.8999",
    stroke: "#E0410E",
    strokeWidth: 0.67,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.221 37.7507C140.024 20.2455 128.107 3.78174 110.601 0.977864C93.0962 -1.82602 76.6325 10.0917 73.8286 27.5969C71.0247 45.1022 82.9425 61.566 100.448 64.3698C117.953 67.1737 134.417 55.2559 137.221 37.7507Z",
    stroke: "#E0410E",
    strokeWidth: 0.67,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.9 64.9952V0.69519",
    stroke: "#E0410E",
    strokeWidth: 0.67,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.3 59.2951V6.49512",
    stroke: "#E0410E",
    strokeWidth: 0.67,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5999 59.2951V6.49512",
    stroke: "#E0410E",
    strokeWidth: 0.67,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.1 32.8951H73.7999",
    stroke: "#E0410E",
    strokeWidth: 0.67,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.3 51.1952H79.4999",
    stroke: "#E0410E",
    strokeWidth: 0.67,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.3 14.4951H79.4999",
    stroke: "#E0410E",
    strokeWidth: 0.67,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1024_2039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 138.4,
    height: 64.9,
    fill: "white",
    transform: "translate(-0.00012207 0.395142)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripleGlobe);
export default __webpack_public_path__ + "static/media/tripleGlobe.167440a54939775f3d697496a70c6411.svg";
export { ForwardRef as ReactComponent };